import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

// The product mark used in every navbar (public and logged-in), so they always match.
export const BrandLogo = ({ to, onClick }: { to: string; onClick?: () => void }) => (
  <Box
    component={RouterLink}
    to={to}
    onClick={onClick}
    sx={{ display: "flex", alignItems: "center", gap: 1.25, textDecoration: "none", color: "inherit" }}
  >
    <Box
      sx={{
        width: 36,
        height: 36,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        background: "linear-gradient(135deg, #1976d2, #115293)",
        boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
        flexShrink: 0,
      }}
    >
      <SchoolRoundedIcon sx={{ fontSize: 22 }} />
    </Box>
    <Typography sx={{ fontWeight: 700, fontSize: { xs: "1rem", md: "1.125rem" }, color: "#111", letterSpacing: "-0.01em" }} noWrap>
      My Campus Pilot
    </Typography>
  </Box>
);
